import { Message } from "../types";

const STORAGE_KEY = "coachmate-pending-messages";

const read = (): Message[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Message[]) : [];
  } catch {
    return [];
  }
};

const write = (messages: Message[]) => {
  if (!messages.length) {
    localStorage.removeItem(STORAGE_KEY);
    return;
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(messages));
};

export const enqueuePendingMessage = (message: Message) => {
  write([...read(), message]);
};

export const flushPendingMessages = (emit: (message: Message) => void) => {
  const queue = read();
  if (!queue.length) return;
  write([]);
  queue.forEach(emit);
};

export const clearPendingMessages = () => {
  localStorage.removeItem(STORAGE_KEY);
};
